import { type FC, useEffect, useRef, useState } from 'react';
import { _notNil } from '@/littledash';

interface TruncateProps {
  children: string;
  textClass?: string;
  tooltip: string;
}

const Truncate: FC<TruncateProps> = ({ children, textClass, tooltip }) => {
  const ref = useRef<HTMLParagraphElement | null>(null);
  const [showTooltip, setShowTooltip] = useState<boolean>(true);

  useEffect(() => {
    if (_notNil(ref.current) && _notNil(ref.current.parentElement)) {
      const canvas = document.createElement('canvas');
      if (typeof canvas.getContext !== 'function') {
        return;
      }
      const context = canvas.getContext('2d') ?? null;
      if (_notNil(context)) {
        const computedParent = getComputedStyle(ref.current?.parentElement);
        const computedChild = getComputedStyle(ref.current);
        context.font = `${computedChild.getPropertyValue('font-size')} ${computedChild.getPropertyValue(
          'font-family'
        )}`;
        const textWidth = context?.measureText(children);
        const parentWidth =
          ref.current?.parentElement.clientWidth -
          (parseFloat(computedParent.paddingLeft) + parseFloat(computedParent.paddingRight));
        setShowTooltip((textWidth?.width ?? 0) > parentWidth);
      }
    }
    return () => document.getElementsByTagName('canvas')?.[0]?.remove();
  }, [ref, children]);

  return showTooltip ? (
    <p
      ref={ref}
      data-tooltip-id="global-tooltip-id"
      data-tooltip-content={tooltip}
      className={`${textClass ?? ''} truncate`}
    >
      {children}
    </p>
  ) : (
    <p ref={ref} className={`${textClass ?? ''}`}>
      {children}
    </p>
  );
};

export default Truncate;
